<style >
.ck-editor__editable {
    min-height: 500px;
}
</style>
<template>
<div>
    <CCard class="card">
        <CCardHeader class="bg-primary font-weight-bold text-white d-flex align-items-center justify-content-between">Soal Post Test Webinar
            <button class="btn btn-dark" @click="$router.go(-1)">Kembali</button>
        </CCardHeader>
        <CCardBody>
          <form @submit.prevent="postData">
            <div class="form-group">
                <label for="name">
                File Template Soal:
                <a :href="lihatFile" target="_blank">
                    Download file excel template
                </a>
                </label>
                <br />
            </div>
            
            <div class="form-group">
                <label for="name">Unggah Soal Baru</label>              
                <div class="custom-file text-truncate">
                  <input
                      type="file"
                      class="custom-file-input"
                      id="customFileLangHTML"
                      ref="importSoal"
                      @change="fileUpload"
                  />
                  <label
                      class="custom-file-label"
                      for="customFileLangHTML"
                      data-browse="Unggah">
                      {{fileName == "" ? 'Pilih File' : fileName}}
                  </label>
                </div>
                <input type="hidden" name="tipe" value="excel" />
                <input type="hidden" name="id_modul" value="1" />
            </div>
            <div class="form-group">
                <label for="name">Durasi</label>
                <br />
                <div class="input-group">
                <input
                    type="number"
                    placeholder="Durasi"
                    class="form-control"
                    required
                    v-model="modulSoal.durasi"
                    name="file"
                />
                <div class="input-group-prepend">
                    <div class="input-group-text">Menit</div>
                </div>
                </div>
            </div>
            <div class="form-group">
                <label for="name">KKM</label>                
                <input
                    type="number"
                    placeholder="0"
                    class="form-control"
                    required
                    v-model="modulSoal.kkm"
                    name="file"
                />                
            </div>
            <div class="form-group">
              <label for class="font-weight-bold mb-0 col-3 pl-0">Status</label>
              <div class="d-flex align-items-start">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    v-model="modulSoal.statusAktifPostTest"
                    class="custom-control-input"
                    name="status"
                    id="aktif"
                    required
                    :value="'1'"
                  />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="status"
                    id="tidak_aktif"
                    required
                    :value="'0'"
                    v-model="modulSoal.statusAktifPostTest"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for class="font-weight-bold mb-0 col-3 pl-0">Status Retake</label>
              <div class="d-flex align-items-start">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    v-model="modulSoal.statusRetake"
                    class="custom-control-input"
                    name="status-retake"
                    id="aktif-retake"
                    required
                    :value="'1'"
                  />
                  <label class="custom-control-label" for="aktif-retake">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="status-retake"
                    id="tidak_aktif-retake"
                    required
                    :value="'0'"
                    v-model="modulSoal.statusRetake"
                  />
                  <label class="custom-control-label" for="tidak_aktif-retake">Tidak Aktif</label>
                </div>
              </div>
            </div>
            <div class="row mt-5">
                <div class="col">
                <button
                    type="submit"
                    class="btn btn-success float-right"
                    data-dismiss="modal"
                >
                    Simpan
                </button>
                </div>
            </div>
          </form>
        </CCardBody>
    </CCard>
    <CCard>
        <CCardHeader class="bg-primary font-weight-bold text-white d-flex justify-content-between align-items-center">Daftar Soal
            <button class="btn btn-success" @click="createData">Tambah</button>
        </CCardHeader>
        <CCardBody>
            
            <CDataTable 
              style="widht:100% !important" 
              :items="modulSoal.dataSoal" 
              :fields="fields"
              :items-per-page-select='{ label : "Data Per Halaman", class: "float-right" }'  
              :tableFilter='{ label:"Pencarian", placeholder:"Cari Data ..", class: "float-left" }'
              :items-per-page="10"
              :pagination='{ class: "float-right" }'
              hover 
              sorter>
              <template #no="{ index}">
                <td class="py-2">{{ index += 1 }}</td>
              </template>
              <template #soal="{item}">
                <td class="py-2 ">
                  <span  v-html="item.soal.substr(0,200)"></span>
                  
                  <ol type='A'>
                    <li>{{ item.jawabanSatu }}</li>
                    <li>{{ item.jawabanDua }}</li>
                    <li>{{ item.jawabanTiga }}</li>
                    <li>{{ item.jawabanEmpat }}</li>
                  </ol>
                  <ul>
                    <li>Jawaban Benar : {{ getJawabanBenar(item) }}</li>
                  </ul>

                </td>

              </template>
              <template #aksi="{item}">
                <td class="py-2 text-center font-weight-bold">
                  
                  <CButton v-c-tooltip="'Edit'" color="warning" class="btn-sm text-white mx-1" square @click="editData(item)">
                    <font-awesome-icon icon="edit" />
                  </CButton>
                  <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item.idDatModulSoal)">
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </td>
              </template>         
            </CDataTable>
            
        </CCardBody>
    </CCard>

    <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
        size="lg"
      >
        <CForm>
          <CRow>
            <div class="modal-body">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">Soal</label>
                    <ckeditor 
                      :editor="editor" 
                      id="soalPostTest"
                      :class="{
                        'is-invalid': $v.formData.soal.$error, 
                      }"
                      @input="setSoal($event.target.value)"
                      v-model="formData.soal" 
                      :config="editorConfig" 
                      rows="5" 
                      :disabled="action=='lihat'">
                    </ckeditor>  
                    <span v-if="$v.formData.soal.$error" class="text-danger">
                      *Mohon isi kolom soal
                    </span>                  
                  </div>
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">Jawaban A</label>
                    <input
                      :disabled="action=='lihat'"
                      type="text"
                      class="form-control"
                      id="jawaban-A"
                      :class="{
                        'is-invalid': $v.formData.jawabanSatu.$error, 
                      }"
                      @input="setJawabanA($event.target.value)"
                      v-model="formData.jawabanSatu"
                    /> 
                    <span v-if="$v.formData.jawabanSatu.$error" class="text-danger">
                      *Mohon isi kolom jawaban A
                    </span>  
                  </div>
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">Jawaban B</label>
                    <input
                      :disabled="action=='lihat'"
                      type="text"
                      id="jawaban-B"
                      :class="{
                        'is-invalid': $v.formData.jawabanDua.$error, 
                      }"
                      @input="setJawabanB($event.target.value)"
                      v-model="formData.jawabanDua"
                      class="form-control"
                    />
                    <span v-if="$v.formData.jawabanDua.$error" class="text-danger">
                      *Mohon isi kolom jawaban B
                    </span>  
                  </div>
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">Jawaban C</label>
                    <input
                      :disabled="action=='lihat'"
                      id="jawaban-C"
                      :class="{
                        'is-invalid': $v.formData.jawabanTiga.$error, 
                      }"
                      @input="setJawabanC($event.target.value)"
                      v-model="formData.jawabanTiga"
                      type="text"
                      class="form-control"
                    />
                    <span v-if="$v.formData.jawabanTiga.$error" class="text-danger">
                      *Mohon isi kolom jawaban C
                    </span>  
                  </div>
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">Jawaban D</label>
                    <input
                      :disabled="action=='lihat'"
                      id="jawaban-D"
                      :class="{
                        'is-invalid': $v.formData.jawabanEmpat.$error, 
                      }"
                      @input="setJawabanD($event.target.value)"
                      type="text"
                      v-model="formData.jawabanEmpat"
                      class="form-control"
                    />
                    <span v-if="$v.formData.jawabanEmpat.$error" class="text-danger">
                      *Mohon isi kolom jawaban D
                    </span>  
                  </div>
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">Jawaban Benar</label>
                    <multiselect
                      required
                      :disabled="action=='lihat'"
                      id="jawaban-benar"
                      :class="{
                        'is-invalid': $v.formData.jawabanBenar.$error, 
                      }"
                      label="jawaban"
                      placeholder="Pilih Jawaban Benar"
                      @input="pilihJawabanBenar"
                      v-model="modelJawabanBenar"
                      :options="jawaban"
                    ></multiselect>
                    <span v-if="$v.formData.jawabanBenar.$error" class="text-danger">
                      *Mohon isi kolom jawaban benar
                    </span>  
                  </div>
                </div>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Tambah</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postSoal" type="submit" color="success">Simpan</CButton>
        </template>
    </CModal>
</div>
</template>
<script>

import ModulPostTestService from "@/services/pelatihan/posttest/modul-post-test.service";
import baseUrl from "@/services/base-url"
import { required } from "vuelidate/lib/validators";

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { AlertUtils } from "@/mixins/AlertUtils";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false,
    _style: "width:5px; text-align: left",
  },
  {
    sorter: true,
    key: "soal",
    label: "Soal",
    sorter: true,
    filter: false
  },

  {
    key: "aksi",
    _style: "width:20%; text-align: left",
    _style: "text-align: center;",
    sorter: false,
    filter: false
  }
];

export default {
  mixins : [AlertUtils],
  data() {
    return {
      fields,
      myModal: false,
      editor: ClassicEditor,
      editorData: '',
      editorConfig: {
          // The configuration of the editor.
      },
      formData : {
        idDatModulSoal : '',
        idPelatihan : '',
        soal : '',
        jawabanSatu : '',
        jawabanDua : '',
        jawabanTiga : '',
        jawabanEmpat : '',
        jawabanBenar : '',
      },
      jawaban : [
        {
          jawaban : 'Jawaban A',
          isi : 'jawaban_satu'
        },
        {
          jawaban : 'Jawaban B',
          isi : 'jawaban_dua'
        },
        {
          jawaban : 'Jawaban C',
          isi : 'jawaban_tiga'
        },
        {
          jawaban : 'Jawaban D',
          isi : 'jawaban_empat'
        },
      ],
      modelJawabanBenar : [],
      modulSoal : {
        namaPelatihan : '',
        idModulSoal: "",
        statusRetake: "",
        idPelatihan : '',
        dataSoal: [],
        durasi: "",
        statusAktifPostTest : "",
        files: "",
        kkm: "",
      },
      fileName : '',
      action : '',
      lihatFile : ''
    }
  },
  validations: {
    formData: {
      soal : { required },
      jawabanSatu : { required },
      jawabanDua : { required },
      jawabanTiga : { required },
      jawabanEmpat : { required },
      jawabanBenar : { required },
    },
  },
  watch: {
    'myModal': function() {
      if (this.myModal == false) {
        this.clearValidation();
      }
    },
  },
  mounted() {
    this.getData();
    this.lihatFile = baseUrl()+'/files?filename=IMPORT_MODUL_SOAL_PELATIHAN.xlsx&path=pelatihan@posttest';
  },
  methods: {
    setSoal(value) {
      this.formData.soal = value;
      this.$v.formData.soal.$touch();
      if(!this.$v.formData.soal.$error) {
        document.getElementById("soalPostTest").classList.add("is-valid")
      }
    },
    setJawabanA(value) {
      this.formData.jawabanSatu = value;
      this.$v.formData.jawabanSatu.$touch();
      if(!this.$v.formData.jawabanSatu.$error) {
        document.getElementById("jawaban-A").classList.add("is-valid")
      }
    },
    setJawabanB(value) {
      this.formData.jawabanDua = value;
      this.$v.formData.jawabanDua.$touch();
      if(!this.$v.formData.jawabanDua.$error) {
        document.getElementById("jawaban-B").classList.add("is-valid")
      }
    },
    setJawabanC(value) {
      this.formData.jawabanTiga = value;
      this.$v.formData.jawabanTiga.$touch();
      if(!this.$v.formData.jawabanTiga.$error) {
        document.getElementById("jawaban-C").classList.add("is-valid")
      }
    },
    setJawabanD(value) {
      this.formData.jawabanEmpat = value;
      this.$v.formData.jawabanEmpat.$touch();
      if(!this.$v.formData.jawabanEmpat.$error) {
        document.getElementById("jawaban-D").classList.add("is-valid")
      }
    },
    getJawabanBenarForm(item) {
      switch (item.jawabanBenar) {
        case "jawaban_satu":
            return "Jawaban A"
            break;
        case "jawaban_dua":
            return "Jawaban B"
            break;
        case "jawaban_tiga":
            return "Jawaban C"
            break;
        case "jawaban_empat":
            return "Jawaban D"
            break;
        default:
            break;
      }
    },
    getJawabanBenar(item) {
      switch (item.jawabanBenar) {
        case "jawaban_satu":
            return "A"
            break;
        case "jawaban_dua":
            return "B"
            break;
        case "jawaban_tiga":
            return "C"
            break;
        case "jawaban_empat":
            return "D"
            break;
        default:
            break;
      }
    },
    
    editData(item) {
      this.action = "edit"
      this.myModal = true
      this.formData.idPelatihan = this.$route.params.id_workshop_pelatihan
      this.formData.idDatModulSoal = item.idDatModulSoal
      this.formData.soal = item.soal
      this.formData.jawabanSatu = item.jawabanSatu
      this.formData.jawabanDua = item.jawabanDua
      this.formData.jawabanTiga = item.jawabanTiga
      this.formData.jawabanEmpat = item.jawabanEmpat
      this.formData.jawabanBenar = item.jawabanBenar
      this.modelJawabanBenar = {
        jawaban : this.getJawabanBenarForm(item)
      }
    },

    lihatSoal(item) {
      this.action = "lihat"
      this.myModal = true
      this.formData.idPelatihan = this.$route.params.id_workshop_pelatihan
      this.formData.idDatModulSoal = item.idDatModulSoal
      this.formData.soal = item.soal
      this.formData.jawabanSatu = item.jawabanSatu
      this.formData.jawabanDua = item.jawabanDua
      this.formData.jawabanTiga = item.jawabanTiga
      this.formData.jawabanEmpat = item.jawabanEmpat
      this.formData.jawabanBenar = item.jawabanBenar
      this.modelJawabanBenar = {
        jawaban : item.jawabanBenar
      }
    },
    deleteData(idDatModulSoal) {
      
      this.$swal
      .fire({
        title: "Peringatan!",
        text: "Apakah anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        reverseButtons: true
      })
      .then(result => {
        if (result.value) {
          let loader = this.$loading.show({
            container: false ? null : this.$refs.formContainer,
            canCancel: true,
            onCancel: this.onCancel
          });
          ModulPostTestService.deleteSoal(idDatModulSoal)
          .then(response => {
            this.alertDeleteSuccess()
            this.getData();
            loader.hide()
          })
          .catch(error => {
            this.alertError();
            // comment console console.log(error);
            loader.hide()

          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.$swal.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
      });
    },
    createData() {
      this.myModal = true
      this.action = "insert"
      this.formData.idPelatihan = this.$route.params.id_workshop_pelatihan
      this.formData.idDatModulSoal = ''
      this.formData.soal = ''
      this.formData.jawabanSatu = ''
      this.formData.jawabanDua = ''
      this.formData.jawabanTiga = ''
      this.formData.jawabanEmpat = ''
      this.formData.jawabanBenar = ''
    },
    postSoal(){    
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else { 
        if(this.action == "insert") {
          this.tambahSoal();
        } else {
          this.ubahSoal();
        }
        this.clearValidation();
      }    
    },
    clearValidation() {
      this.$v.$reset();
      document.getElementById("soalPostTest").classList.remove("is-valid")
      document.getElementById("jawaban-A").classList.remove("is-valid")
      document.getElementById("jawaban-B").classList.remove("is-valid")
      document.getElementById("jawaban-C").classList.remove("is-valid")
      document.getElementById("jawaban-D").classList.remove("is-valid")
      document.getElementById("jawaban-benar").classList.remove("is-valid")
    },
    ubahSoal() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      ModulPostTestService.ubahSoal(this.formData)
      .then(() => {
        loader.hide();
        this.fileName = ""
        this.myModal = false
        this.getData();
        this.alertEditSuccess();
        
      }).catch(error =>{
        this.myModal = false
        loader.hide();
        this.alertError(error.response.data.message)
      })
    },
    tambahSoal() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      ModulPostTestService.tambahSoal(this.formData)
      .then(() => {
        loader.hide();
        this.fileName = ""
        this.myModal = false
        this.getData();
        this.alertSuccess();
        
      }).catch(error =>{
        this.myModal = false
        loader.hide();
        this.alertError(error.response.data.message)
      })
    },
    pilihJawabanBenar(value) {
      if(value) {
        this.formData.jawabanBenar = value.isi;
        this.$v.formData.jawabanBenar.$touch();
        if(!this.$v.formData.jawabanBenar.$error) {
          document.getElementById("jawaban-benar").classList.add("is-valid")
        }
      } else {
        this.formData.jawabanBenar = null;
        this.$v.formData.jawabanBenar.$touch();
        if(!this.$v.formData.jawabanBenar.$error) {
          document.getElementById("jawaban-benar").classList.add("is-valid")
        }
      }
    },
    fileUpload(e) {
      this.modulSoal.files = e.target.files[0];
      this.fileName = e.target.files[0].name;
      
    },
    postData() {
      this.$refs.importSoal.value = null;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var params = {
        durasi : this.modulSoal.durasi,
        idPelatihan : this.modulSoal.idPelatihan,
        files : this.modulSoal.files,
        kkm : this.modulSoal.kkm,
        statusAktifPostTest : this.modulSoal.statusAktifPostTest,
        statusRetake : this.modulSoal.statusRetake
      };
      ModulPostTestService.importSoal(params)
      .then(() => {
        loader.hide();
        this.fileName = ""
        this.getData();
        this.alertSuccess();
      }).catch(error =>{
        loader.hide();
        this.alertError(error.response.data.message)
      })
    },
    getData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      ModulPostTestService.getModulPostTest(this.$route.params.id_workshop_pelatihan)
      .then(response => {
        this.modulSoal = response.data.singleData
        this.modulSoal.files = ""
        this.modulSoal.namaPelatihan = response.data.singleData.namaPelatihan
        this.modulSoal.idPelatihan = this.$route.params.id_workshop_pelatihan
        loader.hide()
      }).catch(error => {
        // comment console console.log(error)
        loader.hide()
      })
    },
    
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>